import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { ScanActions } from './scan.actions';

@Injectable({
  providedIn: 'root'
})
export class ScanEffects {
  sendScanDocumentEffect$: Observable<Action> = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(ScanActions.submitScanDocumentSuccess),
        tap(() => {})
      ),
    { dispatch: false }
  );
  constructor(private actions$: Actions) {}
}
